import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  margin-top: 2rem;
  width: 90%;
  text-align: ${({ position }) => (position ? "start" : "end")};
  flex-direction: ${({ position }) => (position ? "row" : "row-reverse")};
`;

export const ContainerRight = styled.div`
  display: flex;
  margin-top: 2rem;
  width: 100%;
  flex-direction: row-reverse;
`;

export const MessageIcon = styled.img`
  max-height: 2rem;
  max-width: 2rem;
  border-radius: 100%;
  background-color: lightgray;
`;

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 0.81rem;
  margin-right: 0.81rem;
`;
export const MessageTitle = styled.span`
  font-weight: 600;
  font-size: 0.74rem;
  line-height: 0.95rem;
  color: #a9aeb4;
  display: block;
  text-align: ${({ position }) => (position ? "start" : "end")};
`;

export const MessageBody = styled.span`
  user-select: all;
  margin-top: 0.6rem;
  font-family: "Sora";
  font-style: normal;
  font-weight: 400;
  font-size: 0.8rem;
  line-height: 1rem;
  color: #212326;
  max-width: 25rem;
  overflow-wrap: break-word;
  white-space: pre-line;

  .mention {
    background-color: #d6e5fa;
  }

  .subtask {
    background-color: #40e5a0;
    font-weight: bold;
  }
`;
